import { useFindByQuery } from '../../graphql';
import { useCurrentWorkspace } from '../../auth';

const FIND_ALL_CATEGORIES = `
  query FindAllCategories($filter: CategoryFilter) {
    findCategories(filter: $filter) {
      items {
        id
        name
      }
    }
  }
`;

export const useWorkspaceCategories = () => {
  const workspace = useCurrentWorkspace();

  const { data, isLoading, refetch } = useFindByQuery({
    modelName: 'category',
    query: FIND_ALL_CATEGORIES,
    variables: { filter: { workspace: { eq: workspace?.id } } },
    options: {
      enabled: Boolean(workspace?.id),
    },
  });

  return {
    categories: data?.items || [],
    isLoading,
    refetch,
  };
};
